var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('StartupListTopNav'),_vm._v(" "),_c('ScrollTopButton'),_vm._v(" "),_c('StartupList',{attrs:{"followed-only":_vm.followedOnly,"show-recent":_vm.$attrs.showRecent,"should-blur":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }